// extracted by mini-css-extract-plugin
export default {"body":"Hero_body__G5qUC"};